import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IDropdown } from '@models/dropdown.model';
import { User } from '@models/user.model';
import { Organization } from '@models/organization.model';

export const UserAdminActions = createActionGroup({
  source: 'UserAdmin',
  events: {
    'Page Loaded': emptyProps(),
    'Save Button Pressed': emptyProps(),
    'Get Roles Success': props<{ roles: IDropdown[] }>(),
    'Get Roles Failure': props<{ error: string }>(),
    'Get Organizations Success': props<{ orgs: Organization[] }>(),
    'Get Organizations Failure': props<{ error: string }>(),
    'Add User':  props<{ user: User }>(),
    'Get Users Success': props<{ users: User[] }>(),
    'Get Users Failure': props<{ error: string }>(),
    'Add User Success': props<{ user: User }>(),
    'Add User Failure': props<{ error: string }>(),
    'Update User': props<{ user: User; isLoginUpdate?: boolean }>(),
    'Update User Success': props<{ user: User }>(),
    'Update User Failure': props<{ error: string }>(),
    'Delete User': props<{ user: User }>(),
    'Delete User Success': props<{ userId: string }>(),
    'Delete User Failure': props<{ error: string }>(),
    'Update IsLoading': props<{ isLoading: boolean }>(),
    'Org Search Changed': props<{ value: string }>(),
    'Role Search Changed': props<{ value: string }>(),
    'Set Original Email for Edit' : props<{email: string}>(),
    'Reset User Password Pressed': props<{ userId: string }>(),
    'Reset User Password': props<{userId: string }>(),
    'Reset User Password Success': emptyProps(),
    'Reset User Password Failure': props<{ error: string }>(),
  }
});
